<template>
  <div>
    <Title
      :showMinister="true"
      :showService="true"
    />

    <Breadcrumb :links="breadCrumbData" />

    <Carrusel />

    <div v-if="permiso">
      <Main />
    </div>

    <div v-else>
      <NotPermission :contenido="contenidoLock" />
    </div>
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import Carrusel from "../../../components/private/Carrusel.vue";
import Main from "./perimssion/Main.vue";
import NotPermission from "@/components/private/TextNotPermisionPrueba.vue";
import { mapState } from "vuex";
import axios from "axios";
export default {
  components: {
    Title,
    Breadcrumb,
    Carrusel,
    Main,
    NotPermission
  },
  computed: {
    ...mapState("sesion", ["usuario", "relacionUS"])
  },
  data() {
    return {
      permiso: false,
      breadCrumbData: null,
      contenidoLock: null
    };
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id
          }
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio
          }
        },
        {
          name: "Presentación del Ministro",
          routeName: "ministerio",
          routeParams: {
            idServicio: this.$route.params.idServicio
          }
        }
      ];
    },
    obtenerRelacionUsuarioServicio() {
      const data = JSON.parse(localStorage.getItem("user"));
      const relacionUs = data.servicios.find(
        (s) => s.id === parseInt(this.$route.params.idServicio)
      );
      if (!relacionUs) return;
      if (
        relacionUs.rolId === 6 ||
        relacionUs.permisos.find(p => p.permisoId === 1)
      ) {
        this.permiso = true;
      }
    },
    obtenerContenido: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: "presentacion_ministro"
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=${obj.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data) {
          this.contenidoLock = res.data.info.content;
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    this.setBreadcrumbData();
    this.obtenerRelacionUsuarioServicio();
    this.obtenerContenido();
  }
};
</script>
